import * as CONST from '../ActionTypes';
import * as util from './util';

export const loading = () => ({
  type: CONST.LOADING,
});

export const unLoading = () => ({
  type: CONST.UNLOADING,
});

export const requestSuccess = (typeName, result) => ({
  type: typeName,
  payload: result,
});

export const requestFailure = (typeName, result) => ({
  type: typeName,
  payload: result,
});

/**
 * メール送信
 */
export const sendMail = (param) => (dispatch) => {
  dispatch(loading());
  return fetch(`${process.env.REACT_APP_ENDPOINT}/api/v1/customers/send_email`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(param),
    mode: 'cors',
  })
    .then((payload) => {
      if (payload.status === 200) {
        dispatch(requestSuccess(CONST.SEND_MAIL_SUCCESS, payload));
      } else if (payload.status === 500) {
        dispatch(requestFailure(CONST.SEND_MAIL_FAILURE, payload.e.response || ''));
      } else {
        dispatch(requestFailure(CONST.SEND_MAIL_FAILURE, payload.e.response || ''));
      }
      dispatch(unLoading());
    })
    .catch(() => {
      dispatch(requestFailure(CONST.SEND_MAIL_FAILURE, ''));
      dispatch(unLoading());
    });
};

/**
 * 結果フラグクリア
 */
export const clearResultFlg = () => (dispatch) => {
  dispatch(util.actionType(CONST.CLEAR_CONTACT_RESULT_FLG, null));
};
